import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const NavMenuItemButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'isHighlighted',
})<{ isHighlighted: boolean }>(({ isHighlighted }) => ({
  display: 'block',
  width: '100%',
  textAlign: 'left',
  padding: 'calc(0.75 * var(--mui-spacing)) var(--mui-spacing)',
  borderRadius: 'var(--mui-shape-borderRadius)',
  backgroundColor: isHighlighted ? 'var(--mui-palette-action-hover)' : 'transparent',
  transition: 'background-color 100ms ease-in-out',
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
}));

export const navMenuItemHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 'calc(0.75 * var(--mui-spacing))',
  fontSize: 13,
  fontWeight: 500,
  color: 'var(--mui-palette-text-primary)',
  lineHeight: 1.3,
} as const;

export const navMenuItemIconSx = {
  fontSize: 14,
  color: 'var(--mui-palette-primary-light)',
  flexShrink: 0,
} as const;

export const navMenuItemExternalIconSx = {
  fontSize: 12,
  color: 'var(--mui-palette-text-disabled)',
  ml: 'auto',
} as const;

export const navMenuItemDescriptionSx = {
  fontSize: 11,
  color: 'var(--mui-palette-text-disabled)',
  mt: '1px',
  pl: 'calc(2.75 * var(--mui-spacing))',
  lineHeight: 1.3,
} as const;
